module.exports = __webpack_public_path__ + "static/c5-f7cfd524465c7e34bb880deeb974fbab.jpg";